import { SearchRequest } from '@/shared/interfaces/search-request'
import { PageResponse } from '@/shared/interfaces/page-response'

export abstract class DataSource<T> {
  abstract get items(): T[]

  public abstract destroy(): void
  public abstract fetchData(request: SearchRequest): Promise<PageResponse<T>>
  public abstract isLoading(): boolean
}
